import { TThunkAction } from '../../types/redux/thunk';
import { reorderOffers } from './changeOffersOrderActions';
import { selectIds } from '../../selectors/ids';
import { fetchChangeOffersOrderService } from '../../services/compare';

const RETRY_ATTEMPTS = 2;

interface IParams {
  fromIndex: number;
  toIndex: number;
}

export const changeOffersOrder =
  ({ fromIndex, toIndex }: IParams): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { logger, httpApi }) => {
    dispatch(reorderOffers({ fromIndex, toIndex }));
    const offerIds = selectIds(getState());

    try {
      await fetchChangeOffersOrderService({ httpApi, parameters: { offerIds } }, RETRY_ATTEMPTS);
    } catch (err) {
      logger.error(err, {
        degradation: 'Примененная сортировка не была сохранена!',
        domain: 'src/shared/actions/compare#changeOffersOrder',
        offerIds,
        retries: RETRY_ATTEMPTS,
      });
    }
  };
